module.exports = __webpack_public_path__ + "static/media/insurancePdf.d261f799.pdf";